module.exports = __webpack_public_path__ + "img/012-logout.ee322712.svg";